import { useEffect, useState } from 'react';

import { darkTheme } from '@/components/shared/theme/dark-theme';
import { lightTheme } from '@/components/shared/theme/light-theme';
import { REDUCERS } from '@/constants/reducers';

export default function useThemeManager(theme, dispatch) {
    const [currentTheme, setCurrentTheme] = useState(darkTheme);

    useEffect(() => {
        setCurrentTheme(theme === 'dark' ? darkTheme : lightTheme);
    }, [theme]);

    useEffect(() => {
        const themeInLocalStorage = localStorage.getItem('af-theme');
        if (themeInLocalStorage && themeInLocalStorage !== theme) {
            dispatch({
                type: REDUCERS.UPDATE_THEME,
                payload: themeInLocalStorage === 'dark' ? 'dark' : 'light',
            });
        }
    }, []);

    return currentTheme;
}
